var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    'group-countdown-2': _vm.type === 2,
    'pc-group-countdown': !_vm.isH5,
    'mobile-group-countdown': _vm.isH5,
  }},[_c('div',{staticClass:"count-text"},[_vm._v(" 仅剩 "),(_vm.day)?_c('p',[_c('span',[_vm._v(" "+_vm._s(_vm.day)+" ")]),_vm._v("天 ")]):_vm._e()]),_c('div',{staticClass:"count-time",domProps:{"innerHTML":_vm._s(_vm.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }